import { Popup } from '@approvalmax/ui';
import { selectors } from 'modules/common';
import { State } from 'modules/data';
import { useShallowEqualSelector } from 'modules/react-redux';
import { cancelActivePopup, reloadRequest } from 'pages/requestList/actions';
import { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSetCustomerDecisionInQuote } from 'shared/data/webApp/v1';

import { RejectRequestPopupData } from '../../../../reducers/page/activePopup/rejectRequestPopupReducer';
import { getActivePopup, isActiveRequestLocked } from '../../../../selectors/pageSelectors';
import { messages } from './DeclineCustomerDecisionPopup.messages';
import { CommentEditor, Content, Desciption } from './DeclineCustomerDecisionPopup.styles';

const DeclineCustomerDecisionPopup = memo(() => {
    const dispatch = useDispatch();
    const [commentText, setCommentText] = useState('');
    const { request, isLocked } = useShallowEqualSelector((state: State) => {
        const { requestId } = getActivePopup<RejectRequestPopupData>(state);
        const request = selectors.request.getRequestById(state, requestId);

        return {
            request,
            isLocked: isActiveRequestLocked(state),
        };
    });

    const { mutate: setCustomerDecisionInQuote } = useSetCustomerDecisionInQuote();

    const onDecline = useCallback(() => {
        setCustomerDecisionInQuote(
            { body: { requestId: request.id, companyId: request.companyId, isAccepted: false, commentText } },
            {
                onSettled: () => {
                    dispatch(cancelActivePopup());
                    dispatch(reloadRequest(request.id, request.companyId));
                },
            }
        );
    }, [commentText, dispatch, request.companyId, request.id, setCustomerDecisionInQuote]);

    return (
        <Popup.DefaultContent
            title={messages.popupTitle({
                requestName: request.displayName,
            })}
            buttons={
                <Popup.DefaultContent.Button disabled={isLocked} execute={onDecline} title={messages.rejectButtonTitle}>
                    {messages.rejectButtonText}
                </Popup.DefaultContent.Button>
            }
        >
            <Content>
                <Desciption>{messages.desciption({ authorName: request.author.displayName })}</Desciption>

                <CommentEditor focusOnMount value={commentText} onChange={setCommentText} maxLength={1024} />
            </Content>
        </Popup.DefaultContent>
    );
});

export default DeclineCustomerDecisionPopup;
